var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rule-look-container"},[_c('el-scrollbar',{staticClass:"rule-look-scrollbar",staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{attrs:{"id":_vm.containerId}}),(!_vm.nodesData.length)?_c('el-empty'):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }